export const getParentMenu = (currentMenu, allMenu) => {
  if (allMenu?.children?.some((v) => v?.id === currentMenu?.id)) {
    return allMenu;
  } else {
    let parentMenu = null;
    if (allMenu?.children?.length > 0) {
      for (let i = 0; i < allMenu.children.length; i++) {
        const menuCheck = allMenu.children[i];
        const menuIdx = getParentMenu(currentMenu, menuCheck);
        if (menuIdx) {
          parentMenu = menuIdx;
          break;
        }
      }
      return parentMenu;
    } else return null;
  }
};
